import React from 'react';
import { Countdown, PriceCard, TrustSignals } from './Shared';
export const FinalCtaSection = () => {
  return <section className="bg-biosync py-10 px-5 sm:px-10" data-id="element-98">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-99">
        <h2 className="text-white font-bold text-3xl sm:text-4xl md:text-[36px] leading-tight mb-4 max-w-3xl mx-auto" data-id="element-100">
          "El próximo lunes tu adolescente puede seguir sin herramientas.
          <br className="hidden sm:block" data-id="element-101" /> O puede tener el sistema completo
          desde hoy."
        </h2>

        <p className="text-white/90 text-lg sm:text-xl mb-12" data-id="element-102">
          "¿Cuánto cuesta NO tenerlo?"
        </p>

        <div className="bg-biosync-darkBg p-6 sm:p-8 rounded-2xl max-w-md mx-auto mb-10 shadow-lg" data-id="element-103">
          <h3 className="text-white font-bold text-lg mb-6" data-id="element-104">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </h3>
          <Countdown data-id="element-105" />
        </div>

        <div className="max-w-md mx-auto" data-id="element-106">
          <PriceCard compact={true} ctaText="SÍ, QUIERO MI PACK" data-id="element-107" />
        </div>
      </div>
    </section>;
};